import React from "react";
import { Outlet } from "react-router-dom";
import { AppSidebar } from "../Sidebar/app-sidebar";
import {
  SidebarInset,
  SidebarProvider
} from "../ui/sidebar";
import { MobileSidebarTrigger } from "../ui/mobile-sidebar-trigger";
import TourButton from "../Tour/TourButton";

const Layout = () => {

  return (
    <SidebarProvider defaultOpen={false}>
      <AppSidebar />
      <MobileSidebarTrigger />
      <SidebarInset>
        <div className="flex flex-1 flex-col">
          <main className="flex-1 min-h-0">
            <div className="h-full w-full p-2 lg:p-4 flex justify-center">
              <div className="w-full rounded-lg">
                <Outlet />
              </div>
            </div>
          </main>
        </div>
      </SidebarInset>
      <TourButton />
    </SidebarProvider>
  );
};

export default Layout;
